import React from "react";

function UnderConstruction() {
  return (
    <div className="min-h-screen flex items-center">
      <div className="card mx-auto w-full max-w-2xl shadow-xl bg-base-300 text-base-content">
        <div className="p-8 text-center">
          <h1 className="text-3xl font-bold">Sitio en desarrollo 🛠️</h1>
          <p className="mt-4">
            Estamos en acceso temprano. El registro público está temporalmente deshabilitado.
          </p>
          <p className="mt-2">
            Si ya tienes una cuenta de prueba, por favor inicia sesión desde la página principal.
          </p>
        </div>
      </div>
    </div>
  );
}

export default UnderConstruction;
